import { VisuallyHidden } from '@reach/visually-hidden'
import Svg from 'react-inlinesvg'
import { useSelector } from 'react-redux'

import { hasIneligibleItemsSelector } from '@/selectors'
import { translate } from '@/utils/translations'

import DetailsDialog from './DetailsDialog'
import RemoveButton from './RemoveButton'

const ACCORDION_STYLES = [
  'accordion__applied-promo',
  'flex-row',
  'd-flex',
  'justify-content-between'
].join(' ')

const AppliedPromo = () => {
  const promoCode = useSelector(state => state.cart.promoCode.name)
  const hasIneligibleItems = useSelector(hasIneligibleItemsSelector)

  return (
    <div className={ACCORDION_STYLES}>
      <div>
        <Svg aria-hidden="true" src={require('./images/applied-promo.svg')} />
        <p className='u-inline' id='applied-promo-code' tabIndex='-1'>
          <span className='u-push-half--sides u-weight--bold'>
            {promoCode}
          </span>
          {translate('promo_code.applied')}
          <If condition={hasIneligibleItems}>
            <VisuallyHidden>
              {translate('promo_code.discount_not_fully_applicable')}
            </VisuallyHidden>
          </If>
        </p>
        <DetailsDialog />
      </div>
      <RemoveButton />
    </div>
  )
}

export default AppliedPromo
